import { generateNominee } from 'lib/functions/pdfGenerator';
import { formatDate, formatMoney } from 'lib/functions/utils';

import { Payment } from '../../types';

export const handleExportGenericPDF = async (
  payments: Payment[],
  id?: string,
) => {
  const paymentsFormatted = payments.map((x, index: number) => {
    return {
      index: index + 1,
      ...x,
      amountFormatted: formatMoney(x.amount),
      executedAt: x.executedAt && formatDate(new Date(x.executedAt)),
    };
  });
  generateNominee(id, paymentsFormatted);
};
